import { ActionType } from 'typesafe-actions'
import { Moment } from 'moment-timezone'
import * as actions from './actions'
import { Event } from 'features/types/event'

export type DashboardAction = ActionType<typeof actions>

export interface StoreState {
  data: DashboardData
  originalData: DashboardData
  event: Event
  query: DashboardQuery
  sorting: any
  filter: DashboardFilter
}

export type InProgress = {
  ProjectCode: string
  RequestID: number
  CheckNumber: number
  AppointmentDate: string
  State: 'CM' | 'QC'
  Status: 'INIT' | 'INPRO' | 'APPV' | 'REJT'
}

export type FixFromQC = {
  ProjectCode: string
  RequestID: number
  CheckNumber: number
  AppointmentDate: string
  ReturnInDate: number
  ReturnInHour: number
  CheckedDate: string
  State: 'CM' | 'QC'
  Status: 'INIT' | 'INPRO' | 'APPV' | 'REJT'
}

export interface GetDashboardReq {
  ProjectCode: string
  UserEmail: string
}

export interface GetActivityApiResponse extends GetApiResponse<DashboardData> {}

export interface GetApiResponse<T> {
  ResponseData: T
  ResponseCode: string
  ResponseMsg: 'Success' | 'Error'
  RequestTime: string
  Responsetime: string
}

export type DashboardData = {
  TotalInProgress: number
  InProgress: InProgress[]
  TotalFixFromQC: number
  FixFromQC: FixFromQC[]
}

export type DashboardEvent = {
  isFetching: boolean
  error: string
}

export type DashboardFilter = {}

export type DashboardQuery = {
  date: {
    start: undefined | Moment
    end: undefined | Moment
  }
}

export enum TypeOfTask {
  InProgress = 'inProgress',
  FixFromQC = 'fixFromQC',
}
